import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA,  } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService, DialogsService } from '../../custom-material/Services/';
import { DiagnosticModel, UserModel } from '../../main/Models/';
import { PdfDialogComponent } from '../pdf-dialog/pdf-dialog.component';
import { BackDialogComponent } from '../back-dialog/back-dialog.component';

import { environment } from '../../../environments/environment';
import { globalData } from 'src/app/main/Models/global.model';
import { toollist } from './report.tools';


@Component({
  selector: 'app-report',
  templateUrl: './t_report.component.html',
  styleUrls: ['./report.component.less']
})
export class ReportComponent implements OnInit {

  content: string = "Chargement ...";
  labels: Array<string> = [];
  currentKey: number = null;
  diagnostic_id: number;
  diagnostic: DiagnosticModel = new DiagnosticModel({});

  showManual = false;

  toggleManual() { this.showManual = !this.showManual; }
  
  get pdfUrl() {
    if(this.diagnostic.rapport == null || this.diagnostic.rapport=='') return '';
    return environment.baseUrl+'/'+this.diagnostic.rapport+'/rapport.pdf';
  }

  pdfDate = Date.now();
  get uniqPdfUrl() {
    if(this.diagnostic.rapport=='API-PDF') 
      return environment.apiBaseUrl+'/report-pdf/'+this.diagnostic.id
              +'?mode=pdf&token='+localStorage.getItem('access_token');

    
    return '';
  }
  showPdf = false;

  get isSuperadmin() {
    return this.apiService.connectedUser.state==3;
  }
  

  get isAuditor() {
    return this.apiService.connectedUser.isAuditor;
  }

  autoSave = false;
  autoSaveInterval = null;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private gd: globalData,
    private dialog: MatDialog,
    private dialogService: DialogsService,
    private snackBar: MatSnackBar) { 
      this.gd.toolService = this;
      this.gd.toollist = toollist;
    }

  ngOnInit() {
  	this.diagnostic_id = +this.route.snapshot.params['diagnostic'];

    this.loadDiagnostic().then(()=>{

      switch (this.diagnostic.rapport) {
        case undefined:
        case null:
        case '':
          this.loadNewReport();

        case "API":
          this.loadReport();
          break;
        
        default:
          alert('Ancien model de rapport : '+this.diagnostic.rapport);
          break;
      }
    });
  }

  ngOnDestroy()
  {
    clearInterval(this.autoSaveInterval);
    this.save(false).then(()=>{});
      }
  startSaveInterval()
  {
    this.autoSaveInterval = setInterval(() => { this.save(false).then(()=>{}); }, 300000);  //300s=5min
  }

  loadDiagnostic()
  {
    return  new Promise( (resolve, reject) => {
      if(this.gd.current) {
       
        this.diagnostic = this.gd.current;
        this.gd.headerTitle = this.diagnostic.questionnary.name.replace('Questionnaire','Audit');
        this.gd.headerIcon = 'description';

        resolve(true);
      } else {
        this.apiService.getOneFromServer('diagnostic', this.diagnostic_id)
            .then(s => s.subscribe((response:any) => {
             
              this.diagnostic.building.exchange(response.building);
              this.diagnostic.questionnary.exchange(response.questionnary);
              this.diagnostic.exchange(response.diagnostic);
              resolve(true);
            }) );
      }
    });
  }

  loadNewReport()
  {
    this.apiService.getTextFromServer('report', this.diagnostic.id)
      .then(s => s.subscribe((response:string) => {
        this.content = this.tokenizePics(response);
        this.startSaveInterval();
    }) );
  }

  loadReport()
  {
    this.apiService.getTextFromServer('report-pdf', this.diagnostic.id, true)
      .then(s => s.subscribe((response:string) => {
        this.content = this.tokenizePics(response);
        this.startSaveInterval();
    }) );

  }


  showPdfDialog(pdfUrl)
  {
    const dialogRef = this.dialog.open(PdfDialogComponent, {
      width: '500px',
      data: {pdfUrl: pdfUrl}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result) {
        let diagnosticExportModel = {
          id: this.diagnostic.id,
          finished: true
        }
        this.apiService.UpdateToServer('diagnostic', diagnosticExportModel)
        .then(s => s.subscribe((response:any) => {
          this.diagnostic.exchange(response);
          this.router.navigate(['buildings/'+this.diagnostic.building.id]);
        }));
      }
    }); 
  }

  showBackDialog()
  {
    //PdfDialogComponent
    const dialogRef = this.dialog.open(BackDialogComponent, {
      width: '500px',
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      switch (result) {
        case 0: break; //stay here
        case 1: this.gotoQuestionnary(); break;
        case 2: this.gotoBuildings(); break;

        default:
          break;
      }
    }); 
  }

  savePdf() { this.save(true).then(()=>{}); }

  save(savePdf=false) {
    return new Promise((resolve, reject)=>{
      const saveMessage = savePdf ? 'Préparation du pdf ...' : 'Sauvegarde en cours...';

      const saveObject:any = {
        diagnostic_id: this.diagnostic_id,
        savePdf: savePdf,
        path: this.diagnostic.rapport,
        content: this.untokenizePics(this.content)
      }

      this.snackBar.open(saveMessage);
      this.apiService.SaveToServer('report-pdf', saveObject)
        .then(s => s.subscribe((response:any) => {
        this.snackBar.dismiss();

        if(response==null) {
          if(savePdf && (this.diagnostic.rapport!=null && this.diagnostic.rapport!='')) {
            this.showPdf = true;
            this.pdfDate = Date.now();
            this.showPdfDialog(this.uniqPdfUrl);
          }
          return;
        }
        
        this.diagnostic.rapport = response.path;
        
        if(!savePdf) {
            this.content = this.tokenizePics(response.content);
        } else {
          this.pdfDate = Date.now();
          this.showPdfDialog(this.uniqPdfUrl);
        }
        }) );
    });
  }

   gotoQuestionnary()
   {
    this.dialogService.confirm('report-gotoquestionnary-confirm-message', "Attention !")
      .subscribe(confirm => { if(confirm) {
        this.router.navigate(['questionnary/'+this.diagnostic.id]);
      } });
   }

   gotoBuildings()
   {
    this.dialogService.confirm('report-gotobuilding-confirm-message', 'report-gotobuilding-confirm-title')
      .subscribe(confirm => { if(confirm) {
        this.router.navigate(['/', 'buildings', this.diagnostic.building.id]);
      } });
   }

   remake()
   {
    this.dialogService.confirm("report-remake-confirm-message", "report-remake-confirm-title")
      .subscribe(confirm => { if(confirm) {
        this.loadNewReport();
      } });
   }

   tokenizePics(text:string)
   {
        let picPattern = /src=\"([\w\:\/\-\.]*)\"/g;
        let replaceText = text.replace(picPattern, 'img src="$1'+'?token='+localStorage.getItem('access_token')+'"');

        let tinyMcePixPrefixPattern = '/\.\.\/\.\./g';
        replaceText = replaceText.replace(tinyMcePixPrefixPattern, environment.baseUrl);

        return replaceText;
   }

   untokenizePics(text:string)
   {
     let tokenPattern = /\?token=[\w]{40}/g;
     let replaceText = text.replace(tokenPattern, '');

     return replaceText;
   }
}
